import AppRoutes from "./routes/routes"; // Ensure this file exists
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/main.scss";

const App = () => {
  return (
    <div>
      <AppRoutes />
    </div>
  );
};

export default App;
